export default __webpack_public_path__ + "static/media/dollar.f44c1977.svg";